import Text from '@atoms/Text/Text';
import { fadeIn } from '@utility/config/animations';
import { useListingState } from '@utility/context/ListingContext';
import replaceValuesInLabel from '@utility/helpers/replaceValuesInLabel';
import { AnimatePresence, motion } from 'motion/react';

interface Props {
  readonly countLabel: string;
  readonly hasPopulatedQueryState: boolean;
  readonly loading: boolean;
  readonly noResultsLabel: string;
  readonly totalResults: number;
}

const ListingResultsSummary = ({
  countLabel,
  hasPopulatedQueryState,
  loading,
  noResultsLabel,
  totalResults,
}: Props) => {
  const { slicedListItems: listItems } = useListingState();
  return (
    <div className="tw-h-5">
      <AnimatePresence mode="wait">
        {hasPopulatedQueryState && !loading && (
          <motion.div
            key="results"
            variants={fadeIn}
            initial="hidden"
            animate="visible"
            exit="hidden"
          >
            <Text variant="body-small" className="tw-text-left tw-text-grey-70">
              {!loading && listItems?.length === 0
                ? noResultsLabel
                : replaceValuesInLabel(countLabel, [
                    listItems ? listItems?.length : 0,
                    totalResults,
                  ])}
            </Text>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ListingResultsSummary;
